module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/nongsa-2019-desktop.jpg?v=9a7dde6a";